import { DEFAULT_LAYOUT } from '../base';
import type { AppRouteRecordRaw } from '../types';

const DASHBOARD: AppRouteRecordRaw = {
  path: '/',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '工作台',
    requiresAuth: true,
    hideInMenu: true,
    icon: 'icon-dashboard',
    order: 0
  },
  children: [
    {
      path: '/',
      component: () => {
        return import('@/views/page.vue');
      },
      meta: {
        activeMenu: '/'
      }
    }
  ]
};

export default DASHBOARD;
